export const ApiBaseUrl = process.env.REACT_APP_API_BASE_URL;


//#region BlobStorage
// Driven by webpack ENV_CONFIG (REACT_APP_BLOB_* per environment) — same mechanism
// as ApiBaseUrl — so local/dev/uat/prod/staging builds each get their own blob
// account/container/SAS instead of hardcoded values overriding the build config.
export const blobAccount = process.env.REACT_APP_BLOB_ACCOUNT_NAME;
export const blobSas = process.env.REACT_APP_BLOB_SAS;
export const blobContainerName = process.env.REACT_APP_BLOB_CONTAINER_NAME;
// Computed from the account (no trailing slash) to match how common.js concatenates
// `blobStorageUrl + blobSas` and `${blobStorageUrl}/${blobContainerName}/${filename}`.
export const blobStorageUrl = `https://${blobAccount}.blob.core.windows.net`;

//#endregion

export const defaultUrls = {
    defaultResidentPicture: "/template/media/images/nopatientpic.jpg",
    notificationHub: ApiBaseUrl + "NotificationHub",
};

export const apiUrls = {
    upsertResidentImage: ApiBaseUrl + "Resident/UpsertResidentImage",
    getallfacilitycontactsbyfacilityid:
        ApiBaseUrl + "FacilityContact/getallfacilitycontactsbyfacilityid",
    upsertfacilitycontact:
        ApiBaseUrl + "FacilityContact/upsertfacilitycontact",
    getvacationbyid: ApiBaseUrl + "Vacation/getvacationbyid",
    getallvacations: ApiBaseUrl + "Vacation/getallvacations",
    upsertvacation: ApiBaseUrl + "Vacation/upsertvacation",
    searcDoctors: "Physician/SearchDoctors",
    doctorsSearch: "Physician/DoctorsSearch",
    fetchPhysicianList: "Physician/FetchPhyList", 
    upsertPhysicianNew: "Physician/UpsertPhysicianFromGrid",

    SearchInsurance: ApiBaseUrl + "Resident/SearchInsurance",
    //User paths
    getAllUsers: "User/GetAllUser",
    getAllEMR: "Facility/GetEMR",
    upsertEMR: "Facility/UpsertEMR",
    fetchFacilityGroups: "Facility/FetchFacilityGroups",
    updateFacilityStatus: "Facility/UpdateFacilityStatus",
    updateResidentStatus: "Resident/UpdateResidentStatus",
    validateInsurance: "Resident/ValidateInsurance",
    updateResidentWoundStatus: "Wound/UpdateResidentWoundStatus",
    updateResidentWoundPartailStatus: "Process/UpdateResidentWoundPartailStatus",
    updateResidentWoundOrderNowStatus:
        "Process/UpdateResidentWoundOrderNowStatus",

    updateResidentWoundNoOrderStatus: "Process/UpdateResidentWoundNoOrderStatus",
    updateFacilityProcessor: "Process/UpdateFacilityProcessor",

    updateResidentNoOrderStatus: "resident/UpdateResidentNoOrderStatus",
    updateResidentECP: "resident/updateResidentECP",
    updateResidentHospice: "resident/updateResidentHospice",
    createWoundInfoChangeDetail: "wound/createWoundInfoChangeDetail",



    releaseFacilityPartailOrders: "Process/ReleaseFacilityPartailOrders",
    repushFacilityResidents: "Process/RepushFacilityResidents",
    updateSkipOrHoldFacilityStatus: "Process/UpdateSkipOrHoldFacilityStatus",

    // Manual link & release (Administrator only). Records an already hand-created Brightree
    // Sales Order against a resident and marks them released — it never CREATES anything in BT.
    manualReleaseSearchBrightreeSalesOrders: "ManualRelease/SearchBrightreeSalesOrders", // GET ?residentId=
    manualReleaseResolveTemplate: "ManualRelease/ResolveTemplateForSalesOrder",          // GET ?salesOrderId= — live BT lookup
    manualReleaseResidentsPendingLink: "ManualRelease/GetResidentsPendingLink",          // GET ?facilityId= — residents with no SO linked yet
    manualReleaseLinkSingle: "ManualRelease/LinkResidentAndMarkReleased",                // POST single
    manualReleaseLinkBatch: "ManualRelease/LinkAndMarkReleased",                         // POST { items: [...] }


    upsertFacilityUser: "Facility/UpsertFacilityUser",
    upsertFacilityClinician: "Facility/UpsertFacilityClinician",

    getFacilityUsers: "Facility/GetFacilityUsers",
    upsertResidentAOB: ApiBaseUrl + "Resident/UpsertAobForm",
    getFeatureSwitchEnabled: ApiBaseUrl + "/FeatureSwitch/feature/",
    downloadBlankAobForms: ApiBaseUrl + "Facility/DownloadBlankAobForms",
    generateAobPdf: ApiBaseUrl + "Facility/GenerateAoBPdf"
};
